// Currency utility functions
window.CurrencyUtils = {
  // Configuration for exchange rates (EUR as base currency)
  // These rates should be updated regularly or fetched from Shopify's API
  exchangeRates: {
    'EUR': 1.0,
    'USD': 1.08, // Example rate - should be updated
    'GBP': 0.86, // Example rate - should be updated
    'CAD': 1.47, // Example rate - should be updated
    'AUD': 1.65, // Example rate - should be updated
    'JPY': 160.0, // Example rate - should be updated
    'CHF': 0.95, // Example rate - should be updated
    'CNY': 7.8, // Example rate - should be updated
    'INR': 90.0, // Example rate - should be updated
    'BRL': 5.4, // Example rate - should be updated
    'RUB': 100.0, // Example rate - should be updated
    'KRW': 1450.0, // Example rate - should be updated
    'SGD': 1.45, // Example rate - should be updated
    'NZD': 1.78, // Example rate - should be updated
    'MXN': 18.5, // Example rate - should be updated
    'HKD': 8.45, // Example rate - should be updated
    'NOK': 11.5, // Example rate - should be updated
    'SEK': 11.2, // Example rate - should be updated
    'DKK': 7.5, // Example rate - should be updated
    'PLN': 4.3, // Example rate - should be updated
    'HUF': 380.0, // Example rate - should be updated
    'CZK': 25.0, // Example rate - should be updated
    'ILS': 4.0, // Example rate - should be updated
    'ZAR': 20.5, // Example rate - should be updated
    'PHP': 60.0, // Example rate - should be updated
    'TWD': 34.5, // Example rate - should be updated
    'THB': 38.5, // Example rate - should be updated
    'MYR': 5.1, // Example rate - should be updated
    'IDR': 17000.0, // Example rate - should be updated
    'TRY': 33.5, // Example rate - should be updated
    'AED': 3.97, // Example rate - should be updated
    'SAR': 4.05, // Example rate - should be updated
    'QAR': 3.93, // Example rate - should be updated
    'KWD': 0.33, // Example rate - should be updated
    'BHD': 0.41, // Example rate - should be updated
    'OMR': 0.42, // Example rate - should be updated
    'JOD': 0.76, // Example rate - should be updated
    'LBP': 16200.0, // Example rate - should be updated
    'EGP': 33.5, // Example rate - should be updated
    'CLP': 1000.0, // Example rate - should be updated
    'COP': 4200.0, // Example rate - should be updated
    'PEN': 4.0, // Example rate - should be updated
    'ARS': 950.0, // Example rate - should be updated
    'VEF': 35.0, // Example rate - should be updated
    'UYU': 42.0, // Example rate - should be updated
    'PYG': 8000.0, // Example rate - should be updated
    'BOB': 7.5, // Example rate - should be updated
    'CRC': 550.0, // Example rate - should be updated
    'DOP': 63.5, // Example rate - should be updated
    'GTQ': 8.4, // Example rate - should be updated
    'HNL': 26.8, // Example rate - should be updated
    'NIO': 39.8, // Example rate - should be updated
    'PAB': 1.08, // Example rate - should be updated
    'PRY': 8000.0, // Example rate - should be updated
    'SVC': 9.45, // Example rate - should be updated
    'UAH': 42.5, // Example rate - should be updated
    'BYN': 3.5, // Example rate - should be updated
    'BGN': 1.96, // Example rate - should be updated
    'HRK': 7.5, // Example rate - should be updated
    'RON': 5.35, // Example rate - should be updated
    'RSD': 117.0, // Example rate - should be updated
    'MKD': 60.5, // Example rate - should be updated
    'ALL': 105.0, // Example rate - should be updated
    'BAM': 1.96, // Example rate - should be updated
    'GEL': 2.9, // Example rate - should be updated
    'AZN': 1.84, // Example rate - should be updated
    'AMD': 420.0, // Example rate - should be updated
    'KZT': 480.0, // Example rate - should be updated
    'UZS': 13500.0, // Example rate - should be updated
    'KGS': 95.0, // Example rate - should be updated
    'TJS': 11.8, // Example rate - should be updated
    'TMT': 3.78, // Example rate - should be updated
    'MDL': 19.2, // Example rate - should be updated
    'TND': 3.4, // Example rate - should be updated
    'LYD': 5.25, // Example rate - should be updated
    'MAD': 10.8, // Example rate - should be updated
    'DZD': 145.0, // Example rate - should be updated
    'MRO': 38.5, // Example rate - should be updated
    'MUR': 50.0, // Example rate - should be updated
    'XOF': 655.0, // Example rate - should be updated
    'XAF': 655.0, // Example rate - should be updated
    'XPF': 120.0, // Example rate - should be updated
    'GHS': 13.5, // Example rate - should be updated
    'NGN': 1600.0, // Example rate - should be updated
    'KES': 170.0, // Example rate - should be updated
    'UGX': 4100.0, // Example rate - should be updated
    'TZS': 2800.0, // Example rate - should be updated
    'ZMW': 28.5, // Example rate - should be updated
    'NAD': 20.5, // Example rate - should be updated
    'MZN': 68.5, // Example rate - should be updated
    'AOA': 900.0, // Example rate - should be updated
    'MWK': 1800.0, // Example rate - should be updated
    'ZWL': 350.0, // Example rate - should be updated
    'GMD': 72.5, // Example rate - should be updated
    'GNF': 9300.0, // Example rate - should be updated
    'MGA': 4800.0, // Example rate - should be updated
    'CDF': 3000.0, // Example rate - should be updated
    'RWF': 1400.0, // Example rate - should be updated
    'SCR': 15.0, // Example rate - should be updated
    'LRD': 200.0, // Example rate - should be updated
    'SLL': 22000.0, // Example rate - should be updated
    'SOS': 620.0, // Example rate - should be updated
    'SDG': 650.0, // Example rate - should be updated
    'SSP': 1300.0, // Example rate - should be updated
    'SZL': 20.5, // Example rate - should be updated
  },

  /**
   * Update exchange rates from external source (can be called periodically)
   * @param {Object} rates - Object with currency codes as keys and rates as values
   */
  updateExchangeRates(rates) {
    if (rates && typeof rates === 'object') {
      this.exchangeRates = { ...this.exchangeRates, ...rates };
    }
  },

  /**
   * Get the current currency exchange rate relative to EUR
   * @param {string} [currency=Shopify.currency.active] - The currency code
   * @returns {number} Exchange rate (1.0 for EUR, other values for other currencies)
   */
  getExchangeRate(currency = Shopify.currency.active) {
    // If Shopify.currency.rate is available, use it
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) {
      return window.Shopify.currency.rate;
    }
    
    // Try to get rate from Shopify.currency object properties
    if (window.Shopify && window.Shopify.currency) {
      // Check for various possible rate properties
      const possibleRateProps = ['rate', 'exchange_rate', 'conversion_rate'];
      for (const prop of possibleRateProps) {
        if (window.Shopify.currency[prop]) {
          return window.Shopify.currency[prop];
        }
      }
    }
    
    // Use our configured exchange rates
    if (this.exchangeRates[currency]) {
      return this.exchangeRates[currency];
    }
    
    // Fallback
    console.warn(`CurrencyUtils: Exchange rate not available for ${currency}, using fallback rate of 1.0`);
    return 1.0;
  },

  /**
   * Get the currency symbol for a given currency code
   * @param {string} [currency=Shopify.currency.active] - The currency code (e.g. 'GBP', 'EUR')
   * @returns {string} Currency symbol (e.g. '£', '€')
   */
  getCurrencySymbol(currency = Shopify.currency.active) {
    // Map of currency codes to their symbols
    const currencySymbols = {
      'GBP': '£',
      'EUR': '€',
      'USD': '$',
      'CAD': 'C$',
      'AUD': 'A$',
      'JPY': '¥',
      'CHF': 'Fr.',
      'CNY': '¥',
      'INR': '₹',
      'BRL': 'R$',
      'RUB': '₽',
      'KRW': '₩',
      'SGD': 'S$',
      'NZD': 'NZ$',
      'MXN': 'Mex$',
      'HKD': 'HK$',
      'NOK': 'kr',
      'SEK': 'kr',
      'DKK': 'kr',
      'PLN': 'zł',
      'HUF': 'Ft',
      'CZK': 'Kč',
      'ILS': '₪',
      'ZAR': 'R',
      'PHP': '₱',
      'TWD': 'NT$',
      'THB': '฿',
      'MYR': 'RM',
      'IDR': 'Rp',
      'TRY': '₺',
      'AED': 'د.إ',
      'SAR': '﷼',
      'QAR': '﷼',
      'KWD': 'د.ك',
      'BHD': '.د.ب',
      'OMR': '﷼',
      'JOD': 'د.ا',
      'LBP': 'ل.ل',
      'EGP': 'ج.م',
      'CLP': '$',
      'COP': '$',
      'PEN': 'S/.',
      'ARS': '$',
      'VEF': 'Bs.',
      'UYU': '$U',
      'PYG': '₲',
      'BOB': 'Bs.',
      'CRC': '₡',
      'DOP': 'RD$',
      'GTQ': 'Q',
      'HNL': 'L',
      'NIO': 'C$',
      'PAB': 'B/.',
      'PRY': '₲',
      'SVC': '₡',
      'UAH': '₴',
      'BYN': 'Br',
      'BGN': 'лв',
      'HRK': 'kn',
      'RON': 'lei',
      'RSD': 'дин.',
      'MKD': 'ден',
      'ALL': 'Lek',
      'BAM': 'KM',
      'GEL': '₾',
      'AZN': '₼',
      'AMD': '֏',
      'KZT': '₸',
      'UZS': 'лв',
      'KGS': 'лв',
      'TJS': 'ЅМ',
      'TMT': 'm',
      'MDL': 'L',
      'TND': 'د.ت',
      'LYD': 'ل.د',
      'MAD': 'د.م.',
      'DZD': 'د.ج',
      'MRO': 'UM',
      'MUR': '₨',
      'XOF': 'CFA',
      'XAF': 'FCFA',
      'XPF': 'CFP',
      'GHS': '₵',
      'NGN': '₦',
      'KES': 'KSh',
      'UGX': 'USh',
      'TZS': 'TSh',
      'ZMW': 'ZK',
      'NAD': 'N$',
      'MZN': 'MT',
      'AOA': 'Kz',
      'MWK': 'MK',
      'ZWL': 'Z$',
      'GMD': 'D',
      'GNF': 'FG',
      'MGA': 'Ar',
      'CDF': 'FC',
      'RWF': 'FRw',
      'SCR': '₨',
      'LRD': 'L$',
      'SLL': 'Le',
      'SOS': 'S',
      'SDG': 'ج.س.',
      'SSP': '£',
      'SZL': 'L',
      'TZS': 'TSh',
      'UGX': 'USh',
      'ZMW': 'ZK',
      'ZWL': 'Z$'
    };

    // Get the currency symbol, default to currency code if symbol not found
    return currencySymbols[currency] || currency;
  },

  /**
   * Get the decimal separator for a given currency code
   * @param {string} [currency=Shopify.currency.active] - The currency code (e.g. 'GBP', 'EUR')
   * @returns {string} Decimal separator ('.' or ',')
   */
  getDecimalSeparator(currency = Shopify.currency.active) {
    // Currencies that use comma as decimal separator
    const commaSeparatorCurrencies = [
      'EUR', 'BRL', 'RUB', 'PLN', 'CZK', 'DKK', 'SEK', 'NOK', 'HUF', 'RON', 'BGN', 'HRK', 'RSD', 'MKD', 'ALL', 'BAM', 'GEL', 'AZN', 'AMD', 'KZT', 'UZS', 'KGS', 'TJS', 'TMT', 'MDL', 'TND', 'LYD', 'MAD', 'DZD', 'MRO', 'MUR', 'XOF', 'XAF', 'XPF', 'GHS', 'NGN', 'KES', 'UGX', 'TZS', 'ZMW', 'NAD', 'MZN', 'AOA', 'MWK', 'ZWL', 'GMD', 'GNF', 'MGA', 'CDF', 'RWF', 'SCR', 'LRD', 'SLL', 'SOS', 'SDG', 'SSP', 'SZL'
    ];

    return commaSeparatorCurrencies.includes(currency) ? ',' : '.';
  },

  /**
   * Convert an amount from EUR to the current currency
   * @param {number} amountInEUR - The amount in EUR (in cents)
   * @param {string} [currency=Shopify.currency.active] - The target currency code
   * @returns {number} The converted amount in cents
   */
  convertFromEUR(amountInEUR, currency = Shopify.currency.active) {
    if (currency === 'EUR') {
      return amountInEUR;
    }
    
    const rate = this.getExchangeRate(currency);
    return Math.round(amountInEUR * rate);
  },

  /**
   * Format a price in cents to the appropriate currency format
   * @param {number} cents - The price in cents
   * @param {string} [currency=Shopify.currency.active] - The currency code (e.g. 'GBP', 'EUR')
   * @returns {string} Formatted price string (e.g. '$7.20')
   */
  formatMoney(cents, currency = Shopify.currency.active) {
    // Coerce to a finite number of cents
    let safeCents = Number(cents);
    if (!Number.isFinite(safeCents)) {
      safeCents = 0;
    }
    const amount = safeCents / 100;
    const symbol = this.getCurrencySymbol(currency);
    const decimalSeparator = this.getDecimalSeparator(currency);
    const formattedAmount = amount.toFixed(2).replace('.', decimalSeparator);
    return `${symbol}${formattedAmount}`;
  }
}; 